import type { Table } from '../types';

export const initialTables: Table[] = [
    // Main Dining Area
    { id: 1, name: 'Table 1', capacity: 2, status: 'available', shape: 'square', x: 10, y: 15 },
    { id: 2, name: 'Table 2', capacity: 2, status: 'available', shape: 'square', x: 10, y: 40 },
    { id: 3, name: 'Table 3', capacity: 4, status: 'occupied', shape: 'square', x: 10, y: 65 },
    { id: 4, name: 'Table 4', capacity: 4, status: 'available', shape: 'square', x: 25, y: 15 },
    { id: 5, name: 'Table 5', capacity: 4, status: 'available', shape: 'square', x: 25, y: 65 },
    { id: 6, name: 'Table 6', capacity: 6, status: 'available', shape: 'square', x: 40, y: 15 },
    { id: 7, name: 'Table 7', capacity: 6, status: 'available', shape: 'square', x: 40, y: 65 },
    { id: 8, name: 'Table 8', capacity: 8, status: 'occupied', shape: 'square', x: 55, y: 40 },
    
    // Bar Area
    { id: 9, name: 'Bar 1', capacity: 1, status: 'available', shape: 'round', x: 80, y: 20 },
    { id: 10, name: 'Bar 2', capacity: 1, status: 'available', shape: 'round', x: 80, y: 45 },

    // Patio Area
    { id: 11, name: 'Patio 1', capacity: 4, status: 'available', shape: 'round', x: 80, y: 75 },
    { id: 12, name: 'Patio 2', capacity: 4, status: 'occupied', shape: 'round', x: 90, y: 75 },
];
